<template>
  <div>
    <b-modal
      :id="modalId"
      modal-class="guide-modal"
      centered
      scrollable
      hide-header
      hide-footer
      visible
    >
      <div class="tour-modal-content">
        <div class="header__tour-modal">
          <div class="tour-avatar">
            <img
              src="https://lh3.googleusercontent.com/a-/AOh14GhLH09iTdcfTCDXXmr5aZ_7VRuCzNCR-VLef0OZvg"
              alt=""
            />
            <span>Savalas Co.</span>
          </div>
          <!-- Emulate built in modal header close button action -->
          <span class="close-icon" @click="$bvModal.hide(modalId)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#fff" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
        </div>
        <div class="body__tour-modal">
          <swiper
            class="swiper"
            ref="tourSwiper"
            :options="swiperOption"
            @slideChange="slideChanged($event)"
          >
            <swiper-slide
              v-for="slide in tourSlider"
              :key="slide.url + Math.floor(Math.random() * 100 - 1)"
            >
              <div class="slide-tour-modal">
                <img v-if="slide.type === 'image'" :src="slide.url" alt="" />
                <Player v-if="slide.type === 'video'" :id="slide.url" />
                <lottie-player
                  v-if="slide.type === 'lottie'"
                  name="scooterAnim"
                  :path="slide.url"
                />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="footer__tour-modal">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Egestas vel
            lobortis non, eu erat lobortis condimentum. Arcu massa neque.
          </p>
          <div class="tour-actions">
            <b-button
              size="sm"
              variant="primary primary-jb"
              @click="startTour()"
            >
              Take Tour
            </b-button>
            <div class="pagination-tour">
              <span
                class="index-tour"
                v-for="n in tourPagination"
                :key="n"
                :class="{
                  active: activeIndex === n - 1
                }"
                @click="goToStep(n, $event)"
              >
              </span>
            </div>
            <b-button
              size="sm"
              variant="secondary secondary-jb"
              @click="hideModal(modalId)"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.40517 1.32826C8.53892 1.02732 8.83735 0.833374 9.16668 0.833374C10.0507 0.833374 10.8986 1.18456 11.5237 1.80968C12.1488 2.43481 12.5 3.28265 12.5 4.16671V6.66671H16.3791C16.7397 6.66337 17.0968 6.7381 17.4259 6.88578C17.7565 7.03417 18.0509 7.25268 18.2887 7.52615C18.5265 7.79963 18.702 8.12154 18.8031 8.46957C18.9041 8.81761 18.9283 9.18346 18.8739 9.54176L17.7239 17.0417C17.7239 17.0419 17.724 17.0414 17.7239 17.0417C17.6334 17.6375 17.3305 18.1813 16.8713 18.5717C16.4132 18.9611 15.8301 19.1723 15.229 19.1667H3.33334C2.6703 19.1667 2.03442 18.9033 1.56558 18.4345C1.09674 17.9656 0.833344 17.3297 0.833344 16.6667V10.8334C0.833344 10.1703 1.09674 9.53445 1.56558 9.06561C2.03442 8.59677 2.6703 8.33337 3.33334 8.33337H5.29178L8.40517 1.32826ZM6.66668 9.34355L9.6732 2.57887C9.92435 2.659 10.1553 2.79833 10.3452 2.9882C10.6577 3.30076 10.8333 3.72468 10.8333 4.16671V7.50004C10.8333 7.96028 11.2064 8.33337 11.6667 8.33337H16.3833L16.3928 8.33332C16.5136 8.33195 16.6332 8.35686 16.7434 8.40633C16.8536 8.45579 16.9518 8.52863 17.0311 8.61978C17.1103 8.71094 17.1688 8.81825 17.2025 8.93426C17.2362 9.05016 17.2442 9.17199 17.2262 9.29132C17.2262 9.29121 17.2261 9.29143 17.2262 9.29132L16.0761 16.7918C16.046 16.9905 15.945 17.1716 15.7919 17.3018C15.6388 17.4319 15.4437 17.5024 15.2428 17.5001L6.66668 17.5V9.34355ZM5.00001 17.5V10H3.33334C3.11233 10 2.90037 10.0878 2.74409 10.2441C2.58781 10.4004 2.50001 10.6124 2.50001 10.8334V16.6667C2.50001 16.8877 2.58781 17.0997 2.74409 17.256C2.90037 17.4122 3.11233 17.5 3.33334 17.5H5.00001Z"
                  fill="var(--theme-color)"
                />
              </svg>
              Got It!
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <v-tour name="joinsTour" :steps="steps" :options="{ highlight: true }">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <div slot="header">
              <div class="v-step__header">
                <div>
                  Header
                  <span class="close-icon" @click="tour.finish">
                    <svg
                      data-v-57fc8e57=""
                      width="24"
                      height="24"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        data-v-57fc8e57=""
                        cx="16"
                        cy="16"
                        r="16"
                        fill="#E4E6EB"
                      ></circle>
                      <g data-v-57fc8e57="" clip-path="url(#clip0)">
                        <path
                          data-v-57fc8e57=""
                          d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                          fill="#606770"
                        ></path>
                      </g>
                      <defs data-v-57fc8e57="">
                        <clipPath data-v-57fc8e57="" id="clip0">
                          <rect
                            data-v-57fc8e57=""
                            width="14.2222"
                            height="14.2222"
                            fill="white"
                            transform="translate(8.88867 8.88889)"
                          ></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
            <div slot="content">
              <div class="v-step__content">
                <lottie-player
                  name="scooterAnim"
                  path="https://assets2.lottiefiles.com/packages/lf20_hu2LUv.json"
                />
                <div>Content</div>
              </div>
            </div>
            <template>
              <div slot="actions" class="d-flex actions-">
                <button
                  @click="tour.previousStep"
                  class="secondary-jb"
                  v-if="tour.currentStep !== 0"
                >
                  Previous step
                </button>
                <button @click="togglePrevious" class="secondary-jb" v-else>
                  Previous step
                </button>
                <button
                  @click="tour.nextStep"
                  class="primary-jb"
                  v-if="tour.currentStep !== tour.steps.length - 1"
                >
                  Next step
                </button>

                <button
                  @click="tour.finish"
                  class="primary-jb"
                  v-if="tour.currentStep === tour.steps.length - 1"
                >
                  Finish
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper.scss";
//import Player from "../player/Player";
import VueLottiePlayer from "vue-lottie-player";

export default {
  name: "TourModal",
  props: {
    videoURL: {
      type: String
    },
    steps: {
      type: Array
    },
    tourSlider: {
      type: Array
    }
  },
  data() {
    return {
      modalId: "modal-tutorial",
      visible: false,
      activeIndex: 0,

      swiperOption: {
        // edgeSwipeThreshold: 10,
        // edgeSwipeDetection: true,
        // noSwiping: false
        // grabCursor: true,
        // freeMode: true,
        // freeModeMomentum: false
      }
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    Player,
    lottiePlayer: VueLottiePlayer
  },
  computed: {
    tourPagination() {
      return this.tourSlider.length;
    }
  },
  methods: {
    slideChanged(e) {
      console.log(e.activeIndex);
      this.activeIndex = e.activeIndex;
    },
    togglePrevious() {
      this.$tours["joinsTour"].finish();
      this.$bvModal.show(this.modalId);
    },
    startTutoial() {
      this.$bvModal.show(this.modalId);
    },
    hideModal(id) {
      this.$store.dispatch("user/updateTourStatus");
      this.$bvModal.hide(id);
    },

    startTour() {
      this.$bvModal.hide(this.modalId);
      this.$tours["joinsTour"].start();
    },

    goToStep(step, event) {
      var _this = event.target;

      if (_this.classList.contains("active")) return false;
      else {
        document.querySelector(".index-tour.active").classList.remove("active");
        _this.classList.add("active");
      }
      this.activeIndex = step - 1;
      this.$refs.tourSwiper.$swiper.slideTo(step - 1, 200);
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/tourModal.css";

.guide-modal___BV_modal_content_ {
  border-radius: 16px;
}
.modal-body {
  padding: 0;
}
.tour-modal-content {
  position: relative;
}
.v-step {
  background-color: #fff !important;
  color: #474d52 !important;
  border-radius: 16px !important;
  //filter: drop-shadow(6px 6px 20px rgb(20 36 74 / 25%)) !important;
  //border: 1px solid #ddd;
}
.v-step__content {
  .pagination-tour {
    margin-top: 12px;
  }
}

.actions- {
  column-gap: 20px;
}
.v-step__header {
  border-radius: 16px !important;
  background-color: #fff !important;
  color: #474d52;
  text-align: left;
  .close-icon {
    position: absolute;
    top: 10px;
    cursor: pointer;
    right: 10px;
    svg {
      box-shadow: 0px 4px 4px #eee;
    }
  }
}
.pagination-tour {
  @media (max-width: 768px) {
    position: absolute;
    bottom: 75px;
    left: 50%;
    transform: translateX(-50%);
  }
  .index-tour {
    height: 8px;
    width: 8px;
    //float: left;
    //margin-right: 20px;
    background-color: #ddd;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover,
    &.active {
      //pointer-events: none;
      background: var(--theme-color);
    }
  }

  .index-tour:last-child {
    margin-right: 0;
  }

  .index-tour.active {
    //width: 30px;
    cursor: auto;
  }

  display: flex;
  justify-content: center;
  column-gap: 12px;
  //.index-tour {
  //  height: 8px;
  //  width: 8px;
  //  border-radius: 50%;
  //  background: #dddddd;
  //  cursor: pointer;
  //  transition: all 0.3s ease;
  //  &:hover,
  //  &.disabled {
  //    //pointer-events: none;
  //    background: var(--theme-color);
  //  }
  //}
}
.body__tour-modal {
  background-color: #ddbc9e;
  @media (min-width: 768px) {
    min-height: 352px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .vimeo {
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 88%;
    height: 100%;
    @media (min-width: 768px) {
      //top: 0px;
    }
  }
  .slide-tour-modal {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 352px;
    img {
      width: 90%;
    }
    @media (max-width: 600px) {
      width: 100vw;
    }
    @media (min-width: 768px) {
      img {
        min-height: 428px;
        height: calc(100% - 100px);
      }
    }
  }
}
.header__tour-modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 24px;
  z-index: 19;
  .tour-avatar {
    width: fit-content;
    padding: 8px 12px;
    height: 40px;
    background: rgba(71, 77, 82, 0.3);
    border-radius: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 8px;

    img {
      height: 24px;
      width: 24px;
      border-radius: 50%;
    }
    span {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #ffffff;
    }
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
}
.footer__tour-modal {
  padding: 38px 24px 24px 24px;
  position: relative;
  p {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    margin-bottom: 24px;
    color: #474d52;
  }
  .tour-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 768px) {
      padding-top: 20px;
    }
    .primary-jb {
      width: 142px;
      height: 43px;
    }
    .secondary-jb {
      width: 142px;
      height: 43px;
      border: 1px solid rgba(85, 126, 251, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(85, 126, 251, 0.1);
      border-radius: 8px;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 25px;
      color: var(--theme-color);
      column-gap: 12px;
      transition: all 0.2s ease-in-out;
      &:hover {
        background: rgba(85, 126, 251, 1);
        color: #fff;
        path {
          fill: #fff;
        }
      }
    }
  }
}
.primary-jb {
  width: 142px;
  height: 43px;
  background-color: var(--theme-color);
  color: white;
  border: 1px solid var(--theme-color);
  border-radius: 32px;
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: 0px 4px 4px 0px rgba(85, 126, 251, 0.4);
  }
}
.secondary-jb {
  width: 142px;
  height: 43px;
  border: 1px solid rgba(85, 126, 251, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(85, 126, 251, 0.1);

  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;
  color: var(--theme-color);
  column-gap: 12px;
  transition: all 0.2s ease-in-out;
  border-radius: 32px;

  &:hover {
    background: rgba(85, 126, 251, 1);
    color: #fff;
    path {
      fill: #fff;
    }
  }
}
</style>
